import comp from "./ToddleDoc";
export default comp;
